"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptForBinaryChoice = exports.BinaryModal = void 0;
const React = __importStar(require("react"));
const react_modal_1 = __importDefault(require("react-modal"));
const utilities_1 = require("../utilities");
const react_modal_utilities_1 = require("./shared/react-modal-utilities");
const z_index_1 = require("../z-index");
function BinaryModal({ OnClose, Question, YesText = "OK", NoText = "Cancel", Dimensions = { Width: 500, Height: "SizeToContent" }, Show = false, Title, ContentStyle, OverlayStyle, TitleStyle }) {
    const [show, setShow] = React.useState(!!Show);
    const close = (response) => {
        setShow(false);
        OnClose(response);
    };
    const contentStyle = Object.assign(Object.assign({}, react_modal_utilities_1.verticalCenterStyle), ContentStyle || {});
    const overlayStyle = Object.assign({
        zIndex: z_index_1.modalZIndex
    }, OverlayStyle || {});
    return React.createElement(react_modal_1.default, { isOpen: show, onRequestClose: () => close(false), style: {
            content: Object.assign(Object.assign({}, contentStyle), { width: `${Dimensions.Width}px`, height: typeof Dimensions.Height === "number" ? `${Dimensions.Height}px` : undefined, padding: 0 }),
            overlay: overlayStyle
        }, ariaHideApp: false },
        React.createElement("div", { className: "modal-title", style: TitleStyle }, Title),
        React.createElement("div", { className: "modal-body" },
            React.createElement("div", null,
                React.createElement("p", null, Question)),
            React.createElement("div", { className: "button-strip d-flex", style: { justifyContent: "center" } },
                React.createElement("button", { onClick: () => close(true), className: "btn btn-light" }, YesText),
                React.createElement("button", { onClick: () => close(false), className: "btn btn-light" }, NoText))));
}
exports.BinaryModal = BinaryModal;
/** Show a binary choice UI
 * @description Uses a temporary element which is removed
 * after the interaction is complete.
 */
function PromptForBinaryChoice(props) {
    return __awaiter(this, void 0, void 0, function* () {
        return utilities_1.ShowReactPromise((resolve, reject) => {
            const modalProps = Object.assign(Object.assign({}, props), { Show: true, OnClose: resolve });
            return React.createElement(BinaryModal, Object.assign({}, modalProps));
        });
    });
}
exports.PromptForBinaryChoice = PromptForBinaryChoice;
//# sourceMappingURL=binary-modal.js.map